function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 6.25l4.5-4.5m0 4.5l-4.5-4.5",
  stroke: "#DD421A",
  strokeWidth: 1.5
});

function SvgSmallXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none"
  }, props), _ref);
}

export default SvgSmallXIcon;